// import apiClient from './authService'
import apiClient from '../../shared/auth/services'

export const inquiryService = {
  async sendInquiry(inquiryData) {
    try {
      const response = await apiClient.post('/sendInquiry', {
        name: inquiryData.name,
        userMailAddress: inquiryData.email,
        subject: inquiryData.subject,
        content: inquiryData.content,
      })
      
      return response.data
    } catch (error) {
      console.error('Send inquiry error:', error)
      throw error
    }
  },
}

export default inquiryService
